import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const OnboardingLayoutContentLarge = ({ className, children }) => {
  const classes = classNames({
    [className]: !!className,
    'onboarding-layout-content-large': true,
  });

  return <div className={classes}>{children}</div>;
};

OnboardingLayoutContentLarge.propTypes = propTypes;

export default OnboardingLayoutContentLarge;
